import PropTypes from 'prop-types';
import { animated, useChain, useSpring, useSpringRef } from 'react-spring';

import useMeasure from 'hooks/useMeasure';

import './styles.css';

const ExpandAnimation = ({ children, isShown, className, ...rest }) => {
  // We will use this to animate whatever height the alert actually is at any time
  const [bind, { height }] = useMeasure();

  /*
    - This is a two stage animation that needs to reverse itself, hence the use of useChain.
      When showing, the height goes, then the opacity. When hiding it's the opposite.
    - Note that you cannot change value types, eg. cannot go from 0 -> "1rem".
      It must be "0rem" -> "1rem". Witholding a value type will assume "px".
  */

  const heightRef = useSpringRef();
  const heightProps = useSpring({
    ref: heightRef,
    from: { height: 0 },
    to: {
      height: isShown ? height : 0,
    },
  });

  const opacityRef = useSpringRef();
  const opacityProps = useSpring({
    ref: opacityRef,
    from: { opacity: 0 },
    to: { opacity: isShown ? 1 : 0 },
  });

  useChain(
    isShown ? [heightRef, opacityRef] : [opacityRef, heightRef],
    [0, 0.3],
  );

  return (
    <animated.div
      className={className}
      style={{ ...heightProps, ...opacityProps }}
      {...rest}
    >
      <div className="margin-collapse" {...bind}>
        {children}
      </div>
    </animated.div>
  );
};

ExpandAnimation.defaultProps = {
  className: '',
};

ExpandAnimation.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isShown: PropTypes.bool.isRequired,
};

export default ExpandAnimation;
